import React from "react";
import Header from "../../layout/Header";
import LeftBar from "../leftBar/LeftBar";
import SupplierBar from "./sections/SupplierBar";

export default function SupplierDetails() {
  return (
    <>
      <section className="font-soehne">
        <Header />
        <section className="lg:py-20 py-12 xl:w-5/6 w-11/12 mx-auto lg:grid lg:grid-cols-12">
          <LeftBar />
          <SupplierBar />
        </section>
      </section>
    </>
  );
}
